import cn from 'classnames';
import { PropTypes } from 'prop-types';
import React from 'react';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

export const BetaLabel = ({ whiteOnBlack, className }) => {
  return whiteOnBlack ? (
    <Text
      variant={TEXT_VARIANTS.TAG_BOLD_ON_DARK}
      className={cn(
        'bg-midnight-100 bdrs-30 h-chip ta-c pt-01 pb-01 pl-8 pr-8',
        className,
      )}
    >
      {t('lessons.editor.elements.beta')}
    </Text>
  ) : (
    <span
      className={cn(
        'bg-white c-midnight-100 fz-12 fw-b bdrs-30 h-chip ta-c pt-01 pb-01 lh-1rem pl-8 pr-8',
        className,
      )}
    >
      {t('lessons.editor.elements.beta')}
    </span>
  );
};

BetaLabel.propTypes = {
  whiteOnBlack: PropTypes.bool,
  className: PropTypes.string,
};
